<template>
    <div class="form-group" :class="{ 'form-group-floating-label': label }">
        <textarea
            ref="textarea"
            :name="name"
            :value="value"
            class="input"
            :required="required"
            :autofocus="autofocus"
            :disabled="disabled"
            placeholder=" "
            @input="$emit('input', $event.target.value)"
        />

        <label
            v-if="label"
            :for="`input-${name}`"
            class="floating-label"
        >
            {{ label }}
        </label>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                required: false,
                type: String,
                default: null,
            },
            name: {
                required: true,
                type: String,
                default: null,
            },
            label: {
                required: false,
                type: String,
                default: '',
            },
            required: {
                required: false,
                type: Boolean,
                default: false,
            },
            disabled: {
                required: false,
                type: Boolean,
                default: false,
            },
            autofocus: {
                required: false,
                type: Boolean,
                default: false,
            },
        },
    };
</script>
